export { default } from "./product-idea-modal";
